<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="$temAcessoView('CONV-00') && (parentData.idSituacaoConvenio != 9)"
                >Adicionar
            </b-button>
        </b-button-group>
        <b-modal
            id="modalAdicionarCronograma"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Cronograma de Recebimento -
                <b-badge variant="warning">NOVO</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcDescricao">Descrição</label>
                        <b-input-group>
                            <b-form-input
                                id="vcDescricao"
                                type="text"
                                v-model="cronogramaRecebimento.vcDescricao"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback>Descrição é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuParcela">Parcela</label>
                        <b-input-group>
                            <b-form-input
                                id="nuParcela"
                                type="number"
                                min="1"
                                max="999999"
                                step="1"
                                v-model="cronogramaRecebimento.nuParcela"
                            ></b-form-input>
                            <b-form-invalid-feedback>Parcela é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtMesAno">Mês\Ano</label>
                        <b-input-group>
                            <date-picker
                                id="dtMesAno"
                                v-model="cronogramaRecebimento.dtMesAno"
                                :config="$monthPickerOptions"
                                v-mask="'##/####'"
                                @input.native="$v.mesPrevisto.$touch()"
                            ></date-picker>
                            <b-form-invalid-feedback>Mês\Ano é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuValorRecebimento">Valor</label>
                        <b-input-group>
                            <money
                                id="nuValorRecebimento"
                                v-model="cronogramaRecebimento.nuValorRecebimento"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback>Valor é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>

            </b-row>

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvarRecebimento()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object,
        desativarBotao: Boolean
    },

    validations: {
        /*valor: {
            required,
            minValue: minValue(0.01)
        },*/
        cronogramaRecebimento:{
            vcDescricao : {required},
            nuParcela   : {required, minValue: minValue(1)},
            dtMesAno    : {required},
            nuValorRecebimento : {required, minValue: minValue(0.01)}
        }
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            cronogramaRecebimento: {
                codSituacao: null,
                dtLiberacao: null,
                dtMesAno: null,
                idConvenio: 0,
                idCronogramaRecebimento: 0,
                nuParcela: 0,
                nuValorRecebimento: 0,
                percExecucao: null,
                vcDescricao: null,
                vlLiberado: null,
            },
        }
    },

    methods: {
        abrirModal() {
            if (!this.desativarBotao) {
                this.mostrarModal = true;

                this.cronogramaRecebimento.codSituacao = null;
                this.cronogramaRecebimento.dtLiberacao = null;
                this.cronogramaRecebimento.dtMesAno = null;
                this.cronogramaRecebimento.idConvenio = 0;
                this.cronogramaRecebimento.idCronogramaRecebimento = 0;
                this.cronogramaRecebimento.nuParcela = 1;
                this.cronogramaRecebimento.nuValorRecebimento = 0;
                this.cronogramaRecebimento.percExecucao = null;
                this.cronogramaRecebimento.vcDescricao = null;
                this.cronogramaRecebimento.vlLiberado = null;
            }
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvarRecebimento(){
            this.cronogramaRecebimento.idConvenio = this.$route.params.convenioId
            this.cronogramaRecebimento.dtMesAno = '01/'+this.cronogramaRecebimento.dtMesAno
            this.cronogramaRecebimento.dtMesAno = this.$moment(this.cronogramaRecebimento.dtMesAno, 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.cronogramaRecebimento.idCronogramaRecebimento = 0

            this.$store.dispatch('addRequest')
            ConveniosServicos.InserirCronogramaRecebimento(this.cronogramaRecebimento)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramaRecebimento = response.data
                        this.$emit('atualizarLista')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })

            this.fecharModal()
        }
    },
}

</script>

